// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__3HZJo","total":"Cart_total__3kTdc","actions":"Cart_actions__3HNHm","button--alt":"Cart_button--alt__1epfu","button":"Cart_button__3Tg8m"};